var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.554 18H6.232A.23.23 0 0 1 6 17.768V9.875c0-.128.104-.232.232-.232h2.322c.128 0 .232.104.232.232v7.893a.23.23 0 0 1-.232.232m4.642 0h-2.321a.23.23 0 0 1-.232-.232V9.875c0-.128.104-.232.232-.232h2.321c.129 0 .233.104.233.232v.696c.576-.931 1.168-1.392 2.321-1.392 2.12 0 3.25 1.17 3.25 3.649v4.94a.23.23 0 0 1-.232.232h-2.322a.23.23 0 0 1-.232-.232v-4.41c0-1.487-.371-1.858-1.3-1.858-1.021 0-1.485.696-1.485 1.857v4.41a.23.23 0 0 1-.233.233M7.393 7.792C6.623 7.792 6 7.167 6 6.396S6.624 5 7.393 5c.77 0 1.393.625 1.393 1.396s-.624 1.396-1.393 1.396"
})));
export default SvgLinkedin;